(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/views/content/suspensionform.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/views/content/suspensionform.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.views.SuspensionForm = Marionette.View.extend({
    template: function(data) {
      return svs.spelpaus.templates.suspensionform(data);
    },
    regions: {
      suspensionPeriodRegion: '#suspensionPeriodRegion'
    },
    behaviors: {
      ServerSideRendering: {
        regionSetup: function() {
          return {
            suspensionPeriodRegion: {
              view: svs.spelpaus.views.SuspensionPeriod,
              options: {
                model: this.model
              }
            }
          };
        }
      }
    },
    events: {
      'change @ui.suspensionCategory': 'onChooseCategory',
      'focus @ui.suspensionCategory': 'onFocusCategory',
      'blur @ui.suspensionCategory': 'onBlurCategory',
      'change @ui.password': 'onChangePassword',
      'focus @ui.password': 'onFocusPassword',
      'blur @ui.password': 'onBlurPassword',
      'submit form': 'onSubmit'
    },
    ui: {
      suspensionCategory: '.js-suspension-category',
      password: '.js-password'
    },
    onSubmit: function(e) {
      var suspension,
        analyticsData = '',
        self = this,
        requiredFields = ['pauseType', 'pausePeriod'];
      e && e.preventDefault();
      if (svs.core.userSession.getLoginType() === 'PASSWORD' || svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
        requiredFields = ['password'].concat(requiredFields);
      }
      if (svs.components.formValidation.validateRequiredFields(requiredFields)) {
        suspension = {
          product: this.model.get('type')
        };
        if (this.model.get('period') >= 12) {
          suspension.type = 'timeOngoing';
          suspension.termination = this.model.get('period');
        } else {
          suspension.type = 'timeGiven';
          suspension.period = this.model.get('period');
        }
        analyticsData = this.model.get('type') + ':' + this.model.get('period');
        if (svs.core.userSession.getLoginType() === 'PASSWORD' || svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)) {
          var _dialog = new svs.components.dialog.Confirm({
            title: 'Spelpaus',
            icon: 'spelpaus',
            branding: svs.components.dialog.branding.TUR,
            message: [
              {
                type: svs.components.dialog.message.TEXT,
                text: svs.spelpaus.templates.confirm_suspension_request(suspension)
              }
            ],
            actions: [
              {
                title: 'Avbryt',
                callback: function() {
                  var evt = {
                    category: 'Spelpaus',
                    action: 'Cancel',
                    opt_label: analyticsData
                  };
                  svs.components.analytics.trackEvent(evt);
                  _dialog.close();
                }
              },
              {
                title: 'Aktivera Spelpaus',
                showLoader: true,
                callback: function() {
                  self.doSubmit(suspension);
                  var evt = {
                    category: 'Spelpaus',
                    action: 'Activate',
                    opt_label: analyticsData
                  };
                  svs.components.analytics.trackEvent(evt);
                  _dialog.close();
                }
              }
            ]
          });
          svs.components.dialog.api.add(_dialog);
        } else if (svs.core.userSession.getLoginType() === 'BANKID') {
          svs.spelpaus.logger.info('Suspension request with bankid started');
          svs.app.bankid.verifySuspensionRequest(undefined, this.doSubmit.bind(this, suspension), undefined, this);
        } else if (svs.core.userSession.getLoginType() === 'FREJA_EID') {
          svs.spelpaus.logger.info('Suspension request with Freja eID started');
          svs.app.frejaeid.verifySuspensionRequest(undefined, this.doSubmit.bind(this, suspension), undefined, this);
        }
      }
    },
    doSubmit: function(suspension, postToken) {
      var data = {
        suspensions: [suspension]
      };
      if (postToken) {
        svs.spelpaus.logger.debug('postToken: ' + postToken.postToken);
        data.postToken = postToken.postToken;
      } else {
        data.password = this.ui.password.val();
      }
      svs.core.jupiter.call(
        {
          path: '/player/suspensions',
          method: 'POST',
          data: data,
          context: this
        },
        this.onSetSuspensionsSuccess,
        this.onSetSuspensionsError
      );
    },
    onSetSuspensionsSuccess: function(response) {
      if (svs.core.userSession.getLoginType() === 'BANKID') {
        svs.spelpaus.logger.info('Suspension request with bankid done');
      } else if (svs.core.userSession.getLoginType() === 'FREJA_EID') {
        svs.spelpaus.logger.info('Suspension request with Freja eID done');
      }
      var activeProduct = this.model.get('type'),
        changedSuspension = new svs.spelpaus.models.Suspension(
          response.suspensions.filter(function(activeSuspension) {
            return activeSuspension.product === activeProduct;
          })[0],
          { parse: true }
        ),
        newEndedSuspension;

      var showTextMessage = function(accountBalance) {
        if (parseInt(accountBalance, 10) > 0) {
          var _dialog = new svs.components.dialog.Confirm({
            title: 'Spelpaus aktiverad!',
            icon: 'spelpaus',
            branding: svs.components.dialog.branding.TUR,
            message: [
              {
                type: svs.components.dialog.message.TEXT,
                align: 'center',
                text: svs.spelpaus.templates.suspensionsetmessage({
                  suspension: changedSuspension.toJSON(),
                  accountBalance: svs.utils.format.Currency(accountBalance)
                })
              }
            ],
            actions: [
              {
                title: 'Nej, tack'
              },
              {
                title: 'Ja',
                showLoader: true,
                callback: function() {
                  location.href = svs.utils.urlMapping.get('transactionsWithdrawal');
                  _dialog.close();
                }
              }
            ]
          });
          svs.components.dialog.api.add(_dialog);
        } else {
          var _dialogToaster = new svs.components.dialog.Confirm({
            icon: 'spelpaus',
            branding: svs.components.dialog.branding.TUR,
            area: svs.components.dialog.area.TOASTER,
            title: 'Spelpaus aktiverad!',
            message: [
              {
                type: svs.components.dialog.message.TEXT,
                align: 'left',
                text: svs.spelpaus.templates.suspensionsetmessage({
                  suspension: changedSuspension.toJSON()
                })
              }
            ],
            actions: [
              {
                title: 'OK'
              }
            ]
          });
          svs.components.dialog.api.add(_dialogToaster);
        }

        newEndedSuspension = this.model.get('activeSuspensions').find(function(m) {
          return m.get('product') === changedSuspension.get('product');
        });
        if (newEndedSuspension) {
          this.model.get('activeSuspensions').remove(newEndedSuspension);
          newEndedSuspension.set('ended', new moment().format());
          this.model.get('activeSuspensions').add(changedSuspension);
          this.model.get('suspensionHistory').add(newEndedSuspension, { at: 0 });
          if (this.model.get('suspensionHistory').size() > 1) {
            this.render();
          }
        } else {
          this.model.get('activeSuspensions').add(changedSuspension);
          this.render();
        }
      };

      showTextMessage.call(this, undefined);
    },
    onSetSuspensionsError: function(xhr) {
      var messageBoxOptions = {
        title: 'Tekniskt fel',
        message: 'Kontakta kundservice: 0770 - 11 11 11',
        type: svs.components.dialog.type.ERROR,
        buttons: [{ text: 'Stäng' }]
      };
      switch (xhr.status) {
        case 400:
        case 500:
          if (xhr.responseJSON && xhr.responseJSON.error) {
            var errCode = parseInt(String(xhr.responseJSON.error.code).replace(/\s/g, ''), 10);
            switch (errCode) {
              case 225: 
                messageBoxOptions = {
                  title: 'Önskad spelpaus redan aktiverad!',
                  message: 'Du har en pågående spelpaus som omfattar den önskade perioden.',
                  type: svs.components.dialog.type.INFO,
                  buttons: [{ text: 'Stäng' }]
                };
                break;
              case 10320: 
                svs.components.formValidation.showErrorMessage('password', { message: 'Ogiltigt lösenord: Försök igen.' });
                return;
              case 12420:
                messageBoxOptions = {
                  title: 'Fel lösenord',
                  message: 'Du har angivit fel lösenord 3 gånger och har därför blivit utloggad.',
                  buttons: [
                    {
                      text: 'Stäng',
                      callback: function() {
                        window.location.href = '/';
                      }
                    }
                  ]
                };
                break;
              case 173: 
                svs.spelpaus.logger.info('Error posting suspension: ' + xhr.responseJSON.error.message);
                messageBoxOptions = {
                  title: 'Pågående Vegasspel',
                  message: 'Det gick ej att sätta paus. Avsluta ditt Vegasspel och försök igen.',
                  type: svs.components.dialog.type.INFO,
                  buttons: [{ text: 'Stäng' }]
                };
                break;
              case 101: 
              case 12580: 
                svs.spelpaus.logger.info('Error posting suspension: ' + xhr.responseJSON.error.message);
                messageBoxOptions = {
                  title: 'Tekniskt fel',
                  message: 'Var vänlig och försök igen om en liten stund',
                  type: svs.components.dialog.type.INFO,
                  buttons: [{ text: 'Stäng' }]
                };
                break;
              case 210: 
              case 255: 
              case 156: 
                svs.spelpaus.logger.warn('Error posting suspension: ' + xhr.responseJSON.error.message);
                break;
              default:
                svs.spelpaus.logger.warn('Error posting suspension, unknown error code: ' + errCode + ', message: ' + xhr.responseJSON.error.message);
            }
          } else {
            svs.spelpaus.logger.warn('Error posting suspension, no error object in response');
          }
          break;
        default:
          svs.spelpaus.logger.warn('Error posting suspension, unhandled http status error code: ' + xhr.status);
      }
      var _dialog = new svs.components.dialog.Confirm({
        title: messageBoxOptions.title,
        icon: 'spelpaus',
        branding: svs.components.dialog.branding.TUR,
        type: messageBoxOptions.type,
        message: [
          {
            type: svs.components.dialog.message.TEXT,
            text: messageBoxOptions.message
          }
        ],
        actions: [
          {
            title: 'Stäng'
          }
        ]
      });
      svs.components.dialog.api.add(_dialog);
    },
    onFocusCategory: function() {
      svs.components.formValidation._onFocus(this.ui.suspensionCategory);
    },
    onBlurCategory: function() {
      svs.components.formValidation._onBlur(this.ui.suspensionCategory);
    },
    onChooseCategory: function() {
      svs.components.formValidation._onChange(this.ui.suspensionCategory);
      this.model.set('type', this.ui.suspensionCategory.val());
    },
    onFocusPassword: function() {
      svs.components.formValidation._onFocus(this.ui.password);
    },
    onBlurPassword: function() {
      svs.components.formValidation._onBlur(this.ui.password);
    },
    onChangePassword: function() {
      svs.components.formValidation._onChange(this.ui.password);
    },
    onChoosePassword: function() {
      svs.components.formValidation._onChange(this.ui.password);
    }
  });
})(Backbone, _, svs);

 })(window);